import React from 'react'
import { IFieldPop } from '../../../../types'

const FieldPop: React.FC<IFieldPop> = ({text, isEnabled}) => {
  if(!isEnabled) return null

  return (
    <span className='calculator__field__info__pop'>
      { text }
    </span>
  );
}

export default FieldPop
